import React from "react";
import { Helmet } from 'react-helmet-async';
import '../../../assets/styles/Automation.css'
import automationHero from "../../../assets/images/Process Automation.png";
import automationFlow from "../../../assets/images/Process Automation.png";

const AutomationPage = () => {
  return (
    <>
      <Helmet>
        {/* <!-- Primary Meta Tags for SEO --> */}
        <title> MIS Automation – BuddyTech Solutions </title>
        <meta name="description" content="Workflow automation via Zapier, Power Automate, Apps Script and custom scripts." />
        <meta name="keywords" content="workflow automation, business processes" />

        {/* <!-- Open Graph / Facebook Meta Tags --> */}
        <meta property="og:title" content="MIS Automation – BuddyTech Solutions" />
        <meta property="og:description" content="Workflow automation via Zapier, Power Automate, Apps Script and custom scripts." />
        <meta property="og:keywords" content="workflow automation, business processes" />
        <meta property="og:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
        <meta property="og:url" content="https://buddytechsolutions.in/services/mis/automation" />
        <meta property="og:type" content="website" />

        {/* <!-- Optional: Facebook App ID --> */}
        {/* <!-- <meta property="fb:app_id" content="your_facebook_app_id" /> --> */}

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="MIS Automation – BuddyTech Solutions" />
        <meta name="twitter:description" content="Workflow automation via Zapier, Power Automate, Apps Script and custom scripts." />
        <meta name="twitter:keywords" content="workflow automation, business processes" />
        <meta name="twitter:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
      </Helmet>
      <div className="automation-container">
        <header className="automation-hero">
          <div className="automation-hero-content">
            <h1>Business Process Automation</h1>
            <p>
              Streamline your operations with smart automation solutions. We help eliminate manual tasks, improve accuracy, and boost efficiency.
            </p>
          </div>
          <img src={automationHero} alt="Automation Hero" className="automation-hero-img" />
        </header>

        <section className="automation-section">
          <div className="automation-text">
            <h2>What We Automate</h2>
            <p>
              From data syncing to report generation, we automate critical workflows across departments using industry-standard tools and custom scripts.
            </p>
            <ul>
              <li>Sales & CRM Workflow Automation</li>
              <li>Automated Data Entry & Validation</li>
              <li>Email Alerts & Task Triggers</li>
              <li>Scheduling & Resource Allocation</li>
              <li>Report Generation & Distribution</li>
            </ul>
          </div>
          <img src={automationFlow} alt="Automation Flow" className="automation-img" />
        </section>

        <section className="automation-tools">
          <h2>Tools & Technologies</h2>
          <div className="tools-grid">
            <span>Zapier</span>
            <span>Make (Integromat)</span>
            <span>Google Apps Script</span>
            <span>Power Automate</span>
            <span>Notion</span>
            <span>Airtable</span>
            <span>Node.js</span>
            <span>Python</span>
          </div>
        </section>
        <section className="contact-options">
          <div className="contact-card email">
            <h2>📧 Email</h2>
            <p>Send us an email for inquiries, support or collaboration opportunities.</p>
            <a href="mailto:Augustine.g.1992@gmail.com" target="_blank" rel="noopener noreferrer">
              Send Email
            </a>
          </div>

          <div className="contact-card whatsapp">
            <h2>💬 WhatsApp</h2>
            <p>Start a chat with us on WhatsApp for quick responses and updates.</p>
            <a href="https://wa.me/917418763500" target="_blank" rel="noopener noreferrer">
              Chat on WhatsApp
            </a>
          </div>

          <div className="contact-card phone">
            <h2>📞 Call Us</h2>
            <p>Prefer to talk directly? Give us a call anytime during business hours.</p>
            <a href="tel:+917418763500">Call Us</a>
          </div>
        </section>
      </div>
    </>
  );
};

export default AutomationPage;